export default __webpack_public_path__ + "static/media/dashboard-alt-dark.1820a3d5.png";